<template>
    <div class="barContainer">
        <div class="className">
            <slot/>
        </div>
        <div class="barBackground">
            <div class="bar" :style="`transform: translateX(${(1.01 - value) * - 100}%);`" >
                <div class="value">
                    {{Math.round(value.toFixed(2) * 100)}}%
                </div>
            </div>
            <div class="cancel" @click="deleteEvt" v-if="allowDelete">
                <img src="../assets/close.svg">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Bar',
    emits: ['delete'],
    props:{
        value: {
            type: Number,
            default: 0
        },
        allowDelete: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        deleteEvt(){
            this.$emit('delete')
        }
    },
};
</script>

<style scoped>
.barContainer{
    width: 100%;
    max-width: 100%;
    padding: 5px 0;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    
}

.className{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 29px;
    display: flex;
    align-items: center;
    width: 60px;
    height: 29px;
}

.barBackground{
    width: 170px;
    min-width: 170px;
    height: 29px;
    overflow: hidden;
}

.bar {
    display: flex;
    padding: 0 5px;
    justify-content: flex-end;
    width: 101%;
    height: 101%;
    align-items: center;
    transition: all .1s linear;
    transform: translateX(0%);
}

.bar .value{
    color: white;
    font-size: 10px;
}
</style>

<style scoped>
.barContainer:nth-child(4n+1){
    color: #e67701;
}

.barContainer:nth-child(4n+1) .bar{
    background-color: #e67701;
}

.barContainer:nth-child(4n+1) .barBackground{
    background-color: #ffece2;
}

.barContainer:nth-child(4n+2){
    color: #d84c6f;
}

.barContainer:nth-child(4n+2) .bar{
    background-color: #d84c6f;
}

.barContainer:nth-child(4n+2) .barBackground{
    background-color: #ffe9ec;
}

.barContainer:nth-child(4n+3){
    color: #794aef;
}

.barContainer:nth-child(4n+3) .bar{
    background-color: #794aef;
}

.barContainer:nth-child(4n+3) .barBackground{
    background-color: #f1f0ff;
}

.barContainer:nth-child(4n+4){
    color: #1967d2;
}

.barContainer:nth-child(4n+4) .bar{
    background-color: #1967d2;
}

.barContainer:nth-child(4n+4) .barBackground{
    background-color: #d2e3fc;
}

</style>

<style scoped>

.cancel{
    position: absolute;
    width: 22px;
    height: 22px;
    top: 50%; right: 5px;
    transform: translateY(-50%);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0.3;
    padding: 3px;
    background: red;
    border-radius: 50%;
}

.cancel img{
    width: 100%;
}

.cancel:hover{
    opacity: 1;
}

.cancel:hover{
    
}
</style>